import React, { useMemo } from 'react';
import { CssBaseline } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';

import { ReduxLoginWeb } from '@zippeditoolsjs/web';
import SnackAlert from './components/utils/SnackAlert';
import { ThemeModeProvider, useThemeMode } from './context/ThemeModeContext';
import AppLayout from './redux/containers/layout/AppLayout';
import Home from './redux/containers/home/Home';
import Products from './redux/containers/products/Products';
import Tasks from './redux/containers/tasks/Tasks';
import NetworkProvider from './redux/containers/utils/NetworkProvider';
import { createAppTheme } from './styleSheet';

// instantiate services and wire up dependencies
import createStore from 'core/store';
import HTTPService from 'core/services/http';
import AuthSource from 'core/services/authSource';
import DataSource from 'core/services/dataSource';
import ColorSource from 'core/services/colorSource';

const {
  REACT_APP_API_BASE_URL,
  REACT_APP_AUTH_BACKEND_URL,
  REACT_APP_AUTH_BASE_URL,
  REACT_APP_BASE_URL,
} = process.env;

const http = new HTTPService();

const authSource = new AuthSource({
  baseUrl: REACT_APP_AUTH_BACKEND_URL,
  http,
});

const dataSource = new DataSource({
  baseUrl: REACT_APP_API_BASE_URL,
  http,
});

const colors = new ColorSource({});

const store = createStore({
  authSource,
  dataSource,
  colors,
});

function ThemedAppShell() {
  const { resolvedMode } = useThemeMode();
  const theme = useMemo(() => createAppTheme(resolvedMode), [resolvedMode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ReduxLoginWeb appUrlLogin={REACT_APP_AUTH_BASE_URL} appBaseUrl={REACT_APP_BASE_URL} tenattype={'ext'}>
        <NetworkProvider>
          <Router>
            <Routes>
              <Route element={<AppLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/tasks" element={<Tasks />} />
                <Route path="/products" element={<Products />} />
              </Route>
            </Routes>
          </Router>
          <SnackAlert />
        </NetworkProvider>
      </ReduxLoginWeb>
    </ThemeProvider>
  );
}

const App = () => {
  return (
    <StyledEngineProvider injectFirst>
      <Provider store={store}>
        <ThemeModeProvider>
          <ThemedAppShell />
        </ThemeModeProvider>
      </Provider>
    </StyledEngineProvider>
  );
};

export default App;
